import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseHttpResponse, ListHttpResponse } from '../models/core.model';
import { TranslationModel } from '../models/translation.model';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class TranslationService {
  private translationListSubject: BehaviorSubject<string[]>;

  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string,
  ) {
    this.translationListSubject = new BehaviorSubject<string[]>(null);
  }

  public getLanguageList() {
    return new Promise<void>((resolve, reject) => {
      this.http.get<ListHttpResponse<string>>(this.apiUrl + 'translation/language-list')
        .subscribe({
          next: (response) => {
            this.translationListSubject.next(response.model);
            resolve();
          },
          error: (err) => reject(err)
        });
    });    
  }

  public getTranslation(lang: string) {
    return this.http.get<BaseHttpResponse<TranslationModel>>(this.apiUrl + 'translation/' + lang).pipe(map(result => result.model));
  }

  public get translationList(): string[] {
    return this.translationListSubject.value;
  }
}
